import { TextField, TextFieldProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = (errorMessage: string) =>
  makeStyles({
    root: {
      '& .MuiOutlinedInput-root.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor:
            errorMessage === 'Email entered contained redundant spaces. Updated!'
              ? '#3498db'
              : '#e74c3c',
        },
      },
      '& .MuiFormLabel-root.Mui-error': {
        color:
          errorMessage === 'Email entered contained redundant spaces. Updated!'
            ? '#3498db'
            : '#e74c3c',
      },
      '& .MuiFormHelperText-root.Mui-error': {
        color:
          errorMessage === 'Email entered contained redundant spaces. Updated!'
            ? '#3498db'
            : '#e74c3c',
      },
      '& .MuiOutlinedInput-root.Mui-focused.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor:
            errorMessage === 'Email entered contained redundant spaces. Updated!'
              ? '#3498db'
              : '#e74c3c',
        },
      },
    },
  })();

type WIRFieldProps = Omit<TextFieldProps, 'size' | 'variant' | 'margin' | 'fullWidth'> & {
  children?: React.ReactNode;
  validateEmail?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const WIRField: React.FunctionComponent<WIRFieldProps> = ({
  children,
  validateEmail,
  onChange,
  ...textFieldProps
}) => {
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const classes = useStyles(errorMessage);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    if (validateEmail && value.includes(' ')) {
      setError(true);
      setErrorMessage(`Email entered contained redundant spaces. Updated!`);
      value = value.replace(/\s+/g, '');
    } else {
      setError(false);
      setErrorMessage('');
    }

    if (onChange) {
      onChange({ ...event, target: { ...event.target, value } });
    }
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();

    if (validateEmail) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(value)) {
        setError(true);
        setErrorMessage('Please enter a valid email address');
      } else {
        setError(false);
        setErrorMessage('');
      }
    }
  };

  return (
    <TextField
      {...textFieldProps}
      variant="outlined"
      size="small"
      margin="dense"
      fullWidth
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      helperText={errorMessage}
      classes={classes}
    >
      {children}
    </TextField>
  );
};

export default WIRField;
